import KeyList from "@/view/equivalence_configuration/pages/key/list.vue";
import KeyEdit from "@/view/equivalence_configuration/pages/key/edit.vue";
import PlanEdit from "@/view/equivalence_configuration/pages/plan/edit.vue";
import ProviderEdit from "@/view/equivalence_configuration/pages/provider/edit.vue";
import DetailsShow from "@/view/equivalence_configuration/pages/details/show.vue";

const equivalenceConfiguration = [
  // Chaves
  { path: "/equivalence_configuration/", component: KeyList, name: "equiv_conf_list", },
  { path: "/equivalence_configuration/:refPlanId/new", component: KeyEdit, name: "equiv_conf_new" },
  { path: "/equivalence_configuration/:keyId/show", component: KeyEdit, name: "equiv_conf_show" },
  { path: "/equivalence_configuration/:keyId/edit", component: KeyEdit, name: "equiv_conf_edit" },

  // Planos Equivalentes
  { path: "/equivalence_configuration/:keyId/plans", component: PlanEdit, name: "plan_equiv_conf" },

  // Prestadores
  { path: "/equivalence_configuration/:keyId/provider", component: ProviderEdit, name: "prov_equiv_conf" },
 
   // Details
   { path: "/equivalence_configuration/:keyId/details", component: DetailsShow, name: "det_equiv_conf" },
 
];

export default equivalenceConfiguration;
